module.exports = __webpack_public_path__ + "img/voucher-neutral.a6ad73cc.svg";